module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/3/3-18ce7ddb2bd0e903d3f43cb33c234461.jpg";